import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { DashboardData } from "@/types/dashboard";

export function useDashboard() {
  return useQuery<DashboardData>({
    queryKey: ["dashboard"],
    queryFn: () => api<DashboardData>("/api/dashboard"),
    // Pause the 30s poll when the tab is hidden so we don't hammer the
    // backend for data the user isn't looking at. TanStack evaluates
    // this on every interval tick via `refetchIntervalInBackground`
    // defaulting to false.
    refetchInterval: () =>
      typeof document !== "undefined" && document.visibilityState === "hidden"
        ? false
        : 30_000,
    refetchIntervalInBackground: false,
  });
}
